import { i18n } from '@lt/localization';

export const REVIEWS = {
  LT: {
    SLUG: 'LT',
    LABEL: i18n.t('hotel.reviews.LT'),
  },
  TH: {
    SLUG: 'TH',
    LABEL: i18n.t('hotel.reviews.TopHotels'),
  },
};
export const REVIEWS_DEFAULT_VISIBLE = 10;
export const TOPHOTELS_UID = '29c81a2dc6ec79e9d391304a70cb1333';
export const REVIEWS_PATH_SUFFIX = '/reviews';
